// extracted by mini-css-extract-plugin
export default {"row":"TemplatesPanel_row__7DTYQ"};